import React from 'react';
import { DownOutlined, LeftOutlined, RightOutlined, UpOutlined } from '@ant-design/icons';
import noop from 'lodash/noop';
import classnames from 'classnames';

import styles from './index.less';

const CollapseTrigger = ({
  direction, triggerAction, renderCustomChild, isCollapsed,
}) => {
  if (renderCustomChild) {
    return renderCustomChild();
  }
  const isVertical = direction === 'vertical';
  const horizontalIcon = isCollapsed ? <DownOutlined /> : <UpOutlined />;
  const verticalIcon = isCollapsed ? <RightOutlined /> : <LeftOutlined />;
  const IconComponent = isVertical ? verticalIcon : horizontalIcon;

  return (
    <div
      onClick={triggerAction}
      className={classnames(styles.collapseTrigger, {
        [styles.collapseTriggerVertical]: isVertical,
        [styles.collapseTriggerHorizontal]: !isVertical,
      })}
    >
      {IconComponent}
    </div>
  );
};

CollapseTrigger.defaultProps = {
  direction: 'vertical',
  isCollapsed: false,
  renderCustomChild: null,
  triggerAction: noop,
};

export default CollapseTrigger;
